import { render, staticRenderFns } from "./AuthCategoryDetail.vue?vue&type=template&id=78f89e3d&scoped=true"
import script from "./AuthCategoryDetail.vue?vue&type=script&lang=js"
export * from "./AuthCategoryDetail.vue?vue&type=script&lang=js"
import style0 from "./AuthCategoryDetail.vue?vue&type=style&index=0&id=78f89e3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f89e3d",
  null
  
)

export default component.exports